import React from 'react';
import PropTypes from 'prop-types';

import { Spinner, Scrollbar } from '@mssgme/ui';

import ConversationItem from './ConversationItem';
import styles from './ConversationList.scss';

ConversationList.propTypes = {
    items: PropTypes.array.isRequired,
    hasMore: PropTypes.bool,
    onScroll: PropTypes.func,
};

ConversationList.defaultProps = {
    hasMore: false,
};

export default function ConversationList({ items, hasMore, onScroll, children }) {
    return (
        <Scrollbar>
            <div className={styles.root} onScroll={onScroll}>
                {items.map((item) => (
                    <ConversationItem key={`conversation-${item.id}`} {...item} />
                ))}
                {hasMore && <Spinner color="white" />}
                {children}
            </div>
        </Scrollbar>
    );
}
